// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_account_sharing_model from "./web_account_sharing_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function action(send, value) {
  const partial_arg = {
    TAG: /* Accounts */ 41,
    _0: {
      TAG: /* Sharing */ 15,
      _0: value
    }
  };
  return function (param) {
    return Lui_elements.press(send, partial_arg, param);
  };
}

function view(model, send) {
  const source = Signal.map((function (m) {
    return Stdlib__Option.value(Stdlib__Option.bind(m.account_form, (function (p) {
      return p.sharing;
    })), Mapre_web__Web_account_sharing_model.initial("", ""));
  }), model);
  const partial_arg = "Workspace members can use this subscription for authorized sessions. Your login token stays private. Share only with workspaces you trust.";
  const partial_arg$1 = "muted";
  const partial_arg$2 = "Loading sharing workspaces...";
  const partial_arg$3 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$4 = Signal.map((function (p) {
    return p.loading;
  }), source);
  const partial_arg$5 = "No workspaces available for sharing.";
  const partial_arg$6 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$7 = Signal.map((function (p) {
    if (!p.loading && Caml_obj.caml_equal(p.items, /* [] */ 0)) {
      return p.message === "";
    } else {
      return false;
    }
  }), source);
  const partial_arg$8 = Signal.map((function (p) {
    return p.message !== "";
  }), source);
  const partial_arg$9 = Signal.map((function (p) {
    return p.items;
  }), source);
  const partial_arg$10 = Signal.map((function (p) {
    return p.cursor !== undefined;
  }), source);
  const partial_arg$11 = action(send, /* Close */ 0);
  const partial_arg$12 = "ghost";
  const partial_arg$13 = "Close sharing";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___008_) {
      const partial_arg = action(send, /* Refresh */ 1);
      const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___008_.ui_scope, Signal.map(Mapre_web__Web_account_sharing_model.busy, source)));
      const partial_arg$2 = "outline";
      const partial_arg$3 = "Refresh sharing";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$14 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$15 = "wrap";
  const partial_arg$16 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___005_) {
      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (p) {
        return "Sharing " + p.label;
      }), source)));
      const partial_arg$1 = 3;
      return function (param, param$1) {
        return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$4, partial_arg$3, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$7, partial_arg$6, param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.if_(partial_arg$8, (function (param, param$1) {
              return Lui_elements.scoped((function (__lui_context___006_) {
                const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (p) {
                  return p.message;
                }), source)));
                const partial_arg$1 = "notice";
                return function (param, param$1) {
                  return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                };
              }), param, param$1);
            }), param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.keyed(partial_arg$9, (function (w) {
                return w.id;
              }), Stdlib__String.compare, (function (param) {
                const partial_arg = Signal.map((function (w) {
                  if (w.shared) {
                    return !w.current;
                  } else {
                    return false;
                  }
                }), param);
                const partial_arg_0 = function (param$1, param$2) {
                  return Lui_elements.scoped((function (__lui_context___001_) {
                    const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (w) {
                      return w.name;
                    }), param)));
                    return function (param, param$1) {
                      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                    };
                  }), param$1, param$2);
                };
                const partial_arg_1 = {
                  hd: (function (param$1, param$2) {
                    return Lui_elements.scoped((function (__lui_context___002_) {
                      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (w) {
                        if (w.current) {
                          return "Shared with workspace members.";
                        } else if (w.shared) {
                          return "Sharing needs renewed consent.";
                        } else {
                          return "Private to you.";
                        }
                      }), param)));
                      const partial_arg$1 = "muted";
                      return function (param, param$1) {
                        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                      };
                    }), param$1, param$2);
                  }),
                  tl: {
                    hd: (function (param$1, param$2) {
                      return Lui_elements.scoped((function (__lui_context___003_) {
                        const partial_arg = (function ($$event) {
                          const w = Signal.sample(param);
                          action(send, {
                            TAG: /* Change */ 1,
                            _0: w.id,
                            _1: !w.current
                          })($$event);
                        });
                        const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map(Mapre_web__Web_account_sharing_model.busy, source)));
                        const partial_arg$2 = "outline";
                        const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (w) {
                          return (
                            w.current ? "Stop sharing with " : (
                                w.shared ? "Renew sharing with " : "Share with "
                              )
                          ) + w.name;
                        }), param)));
                        return function (param, param$1) {
                          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                        };
                      }), param$1, param$2);
                    }),
                    tl: {
                      hd: (function (param$1, param$2) {
                        return Lui_elements.if_(partial_arg, (function (param$3, param$4) {
                          return Lui_elements.scoped((function (__lui_context___004_) {
                            const partial_arg = (function ($$event) {
                              const w = Signal.sample(param);
                              action(send, {
                                TAG: /* Change */ 1,
                                _0: w.id,
                                _1: false
                              })($$event);
                            });
                            const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map(Mapre_web__Web_account_sharing_model.busy, source)));
                            const partial_arg$2 = "ghost";
                            const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (w) {
                              return "Stop sharing with " + w.name;
                            }), param)));
                            return function (param, param$1) {
                              return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                            };
                          }), param$3, param$4);
                        }), param$1, param$2);
                      }),
                      tl: /* [] */ 0
                    }
                  }
                };
                const partial_arg$1 = {
                  hd: partial_arg_0,
                  tl: partial_arg_1
                };
                const partial_arg$2 = "command-card";
                const partial_arg$3 = 0;
                const partial_arg$4 = 12;
                const partial_arg$5 = 6;
                return function (param, param$1) {
                  return Lui_elements.column(undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, param, param$1);
                };
              }), param, param$1);
            }),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.if_(partial_arg$10, (function (param, param$1) {
                  return Lui_elements.scoped((function (__lui_context___007_) {
                    const partial_arg = action(send, /* More */ 2);
                    const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map(Mapre_web__Web_account_sharing_model.busy, source)));
                    const partial_arg$2 = "outline";
                    const partial_arg$3 = "More sharing workspaces";
                    return function (param, param$1) {
                      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                    };
                  }), param, param$1);
                }), param, param$1);
              }),
              tl: {
                hd: (function (param, param$1) {
                  return Lui_elements.row(undefined, partial_arg$16, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$15, undefined, partial_arg$14, param, param$1);
                }),
                tl: /* [] */ 0
              }
            }
          }
        }
      }
    }
  };
  const partial_arg$17 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$18 = "form-card";
  const partial_arg$19 = 0;
  const partial_arg$20 = 12;
  const partial_arg$21 = 12;
  const partial_arg$22 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$21, undefined, undefined, undefined, undefined, undefined, partial_arg$20, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$19, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$18, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$17, param, param$1);
  };
  const partial_arg$23 = Signal.map((function (m) {
    return Stdlib__Option.bind(m.account_form, (function (p) {
      return p.sharing;
    })) !== undefined;
  }), model);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg$23, partial_arg$22, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
